import { notFoundSVGIcon } from './common';
import { getNumericObjectValues } from '../../../core/utils/general/general';

import {
  SVGIconDetail,
  SVGIconWithoutValue,
  createSVGCircle,
  createSVGPath,
} from './icons';

const sunnyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 1024,
  shapes: [
    createSVGPath(
      'M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384zm0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512zm0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32zm0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32zM195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248zM64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32zm768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32zM195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0zm543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0z'
    ),
  ],
});

const cloudyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 24,
  shapes: [
    createSVGPath(
      'M2.34297 13.7926C1.35505 12.7823 0.905678 11.2987 1.0175 9.98196C1.11755 8.80371 1.65409 7.61403 2.73879 6.83466C3.6837 6.15573 4.93272 5.86744 6.42864 6.04754C7.0781 4.75828 7.94339 3.87499 8.95105 3.39952C10.1252 2.84549 11.3664 2.90609 12.4248 3.34576C13.9333 3.97244 15.1899 5.43859 15.4353 7.18022C15.6592 7.23883 15.8785 7.31091 16.092 7.39524C18.2721 8.25634 20.0627 10.5288 19.7773 13.0959C21.8019 13.586 22.9662 15.277 22.9993 17.0091C23.0183 18.007 22.6603 19.0234 21.8787 19.7888C21.0916 20.5597 19.9549 21 18.5526 21L7.17706 21C3.61934 21 1.77602 17.8849 2.0226 15.1821C2.06559 14.7109 2.17109 14.2416 2.34297 13.7926ZM3.49263 12.0511C3.68372 11.8679 3.89412 11.6971 4.12434 11.5414C5.29189 10.7517 6.85927 10.4221 8.77842 10.6806C9.59509 9.07668 10.6876 8.01159 11.9335 7.45344C12.4023 7.24341 12.88 7.11108 13.3557 7.04674C13.1035 6.23131 12.4681 5.52944 11.6575 5.19274C11.0524 4.94134 10.4048 4.925 9.80452 5.20827C9.20058 5.49324 8.51881 6.14215 7.98358 7.45802C7.78195 7.95372 7.25204 8.2312 6.73444 8.12339C5.3125 7.82722 4.42743 8.08408 3.90581 8.45887C3.37744 8.83851 3.07012 9.447 3.01032 10.1512C2.95003 10.8612 3.13075 11.5364 3.49263 12.0511ZM10.3175 12.1095C11.0062 10.4963 11.9034 9.65844 12.7511 9.27867C13.6015 8.89775 14.5189 8.92424 15.3573 9.25539C17.1117 9.94838 18.2154 11.7918 17.6508 13.5041C17.4178 14.2107 17.9363 14.9334 18.6672 14.9563C20.2392 15.0055 20.981 16.0708 20.9996 17.0473C21.0091 17.5436 20.8334 18.0131 20.4793 18.36C20.1306 18.7015 19.5296 19 18.5526 19L7.17706 19C5.0662 19 3.8484 17.1826 4.01433 15.3638C4.09409 14.4895 4.50102 13.7011 5.24487 13.198C5.99008 12.694 7.21156 12.3847 9.0849 12.7589C9.59289 12.8604 10.1116 12.5918 10.3175 12.1095Z'
    ),
  ],
});

const rainyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 512,
  shapes: [
    createSVGPath(
      'M456.26,139.37c-16.77-16.73-39.17-28.41-65.17-34a16,16,0,0,1-11.19-9,142.24,142.24,0,0,0-42.19-53.21C314.48,25.39,286.23,16,256,16a140.24,140.24,0,0,0-93.5,35.32c-24.2,21.56-40.91,51.34-48.43,85.83a16.05,16.05,0,0,1-11.72,12.18c-25,6.3-35.71,12.54-49.21,24.56C34,190.93,24,214.14,24,240.8c0,30.55,11.23,55.64,32.47,72.56C75.08,328.17,100.5,336,130,336H364c33.2,0,64.11-11.46,87-32.28,23.84-21.65,37-51.67,37-84.52C488,187.71,477,160.11,456.26,139.37Z'
    ),
    createSVGPath(
      'M112,448a16,16,0,0,1-13.3-24.88l32-48a16,16,0,0,1,26.62,17.76l-32,48A16,16,0,0,1,112,448Z'
    ),
    createSVGPath(
      'M160,496a16,16,0,0,1-13.29-24.88l64-96a16,16,0,0,1,26.62,17.76l-64,96A16,16,0,0,1,160,496Z'
    ),
    createSVGPath(
      'M272,448a16,16,0,0,1-13.3-24.88l32-48a16,16,0,0,1,26.62,17.76l-32,48A16,16,0,0,1,272,448Z'
    ),
    createSVGPath(
      'M320,496a16,16,0,0,1-13.3-24.88l64-96a16,16,0,0,1,26.62,17.76l-64,96A16,16,0,0,1,320,496Z'
    ),
  ],
});

const stormyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 64,
  shapes: [
    createSVGPath(
      'M55.9771,25.2549A12.015,12.015,0,0,0,44,14a12.1858,12.1858,0,0,0-1.6792.1162A14.9915,14.9915,0,0,0,14.8623,16.001,8.01,8.01,0,0,0,7,24a7.91,7.91,0,0,0,.0537.916A9.0644,9.0644,0,0,0,2,33a8.8727,8.8727,0,0,0,1.2188,4.5078A.9991.9991,0,0,0,4.08,38H59.74a.9991.9991,0,0,0,.8194-.4268A7.942,7.942,0,0,0,62,33,8.0294,8.0294,0,0,0,55.9771,25.2549Z'
    ),
    createSVGPath(
      'M17,45H13.2808l.6894-2.7573A1,1,0,0,0,13,41H8a1,1,0,0,0-.9614.7251l-2,7A1,1,0,0,0,6,50H7.7192L6.03,56.7573a1,1,0,0,0,1.71.9156l10-11A1,1,0,0,0,17,45Z'
    ),
    createSVGPath(
      'M38,45H34.2808l.6894-2.7573A1,1,0,0,0,34,41H29a1,1,0,0,0-.9614.7251l-2,7A1,1,0,0,0,27,50h1.7192L27.03,56.7573a1,1,0,0,0,1.71.9156l10-11A1,1,0,0,0,38,45Z'
    ),
    createSVGPath(
      'M58.9146,45.5952A1,1,0,0,0,58,45H54.2808l.6894-2.7573A1,1,0,0,0,54,41H49a1,1,0,0,0-.9614.7251l-2,7A1,1,0,0,0,47,50h1.7192L47.03,56.7573a1,1,0,0,0,1.71.9156l10-11A1,1,0,0,0,58.9146,45.5952Z'
    ),
  ],
});

const snowyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 24,
  shapes: [
    createSVGPath(
      'M19.64,8.18h-.18a2.76,2.76,0,0,0,.18-.95,2.88,2.88,0,0,0-2.87-2.87,2.51,2.51,0,0,0-.55.06A5.24,5.24,0,0,0,6.3,6.27h-1a3.82,3.82,0,0,0,0,7.64H19.64a2.87,2.87,0,0,0,0-5.73Z'
    ),
    createSVGCircle({ x: 3.41, y: 20.59, radius: 1.91 }),
    createSVGCircle({ x: 14.86, y: 20.59, radius: 1.91 }),
    createSVGCircle({ x: 9.14, y: 17.73, radius: 0.95 }),
    createSVGCircle({ x: 20.59, y: 17.73, radius: 0.95 }),
    // createSVGPath(
    //   'M21,11H18.87l1-1.45a1,1,0,1,0-1.66-1.1L16.46,11H13V7.54l2.55-1.71a1,1,0,0,0-1.1-1.66L13,5.13V3a1,1,0,0,0-2,0V5.13l-1.45-1a1,1,0,0,0-1.1,1.66L11,7.54V11H7.54L5.83,8.45a1,1,0,0,0-1.66,1.1l1,1.45H3a1,1,0,0,0,0,2H5.13l-1,1.45a1,1,0,0,0,.28,1.38A.94.94,0,0,0,5,16a1,1,0,0,0,.83-.45L7.54,13H11v3.46L8.45,18.17a1,1,0,0,0,1.1,1.66l1.45-1V21a1,1,0,0,0,2,0V18.87l1.45,1A.94.94,0,0,0,15,20a1,1,0,0,0,.55-1.83L13,16.46V13h3.46l1.71,2.55A1,1,0,0,0,19,16a.94.94,0,0,0,.55-.17,1,1,0,0,0,.28-1.38l-1-1.45H21a1,1,0,0,0,0-2Z'
    // ),
  ],
});

const foggyWeatherIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 24,
  shapes: [
    createSVGPath(
      'M18,19c-0.7,0-1.4-0.2-2.1-0.6c-0.6-0.4-1.3-0.4-1.9,0c-1.2,0.8-2.9,0.8-4.1,0c-0.6-0.4-1.3-0.4-1.9,0 c-1.2,0.8-2.9,0.8-4.1,0l-1.5-1C2,17.1,1.9,16.5,2.2,16s0.9-0.6,1.4-0.3l1.5,1c0.6,0.4,1.3,0.4,1.9,0c1.2-0.8,2.9-0.8,4.1,0 c0.6,0.4,1.3,0.4,1.9,0c1.2-0.8,2.9-0.8,4.1,0c0.6,0.4,1.3,0.4,1.9,0l1.5-1c0.5-0.3,1.1-0.2,1.4,0.3c0.3,0.5,0.2,1.1-0.3,1.4 l-1.5,1C19.4,18.8,18.7,19,18,19z'
    ),
    createSVGPath(
      'M18,22c-0.7,0-1.4-0.2-2.1-0.6c-0.6-0.4-1.3-0.4-1.9,0c-1.2,0.8-2.9,0.8-4.1,0c-0.6-0.4-1.3-0.4-1.9,0 c-1.2,0.8-2.9,0.8-4.1,0l-1.5-1C2,20.1,1.9,19.5,2.2,19c0.3-0.5,0.9-0.6,1.4-0.3l1.5,1c0.6,0.4,1.3,0.4,1.9,0 c1.2-0.8,2.9-0.8,4.1,0c0.6,0.4,1.3,0.4,1.9,0c1.2-0.8,2.9-0.8,4.1,0c0.6,0.4,1.3,0.4,1.9,0l1.5-1c0.5-0.3,1.1-0.2,1.4,0.3 c0.3,0.5,0.2,1.1-0.3,1.4l-1.5,1C19.4,21.8,18.7,22,18,22z'
    ),
    createSVGPath(
      'M18.4,7.4h-1c-0.3-1.3-1-2.4-2.1-3.1c-0.5-0.3-1-0.5-1.5-0.6C13.3,2.1,11.8,1,10,1C8.1,1,6.4,2.4,6,4.2H5.2 C3.5,4.2,2,5.7,2,7.5v0.2c0,1.4,0.8,2.6,2,3.1c0,0.1,0,0.2,0,0.3v0.2c0,2,1.6,3.7,3.6,3.7h10.9c2,0,3.6-1.7,3.6-3.7v-0.2 C22,9.1,20.4,7.4,18.4,7.4z M4,7.5c0-0.7,0.6-1.3,1.2-1.3h1.6c0.6,0,1-0.4,1-1C7.9,4,8.8,3,10,3c0.7,0,1.3,0.3,1.7,0.9 c0,0-0.1,0-0.1,0.1C11.5,4,11.4,4,11.3,4c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3 c0,0-0.1,0-0.1,0.1C9.9,4.9,9.8,5.1,9.6,5.2c0,0.1-0.1,0.1-0.1,0.2C9.4,5.5,9.3,5.7,9.2,5.8C9.1,5.9,9.1,6,9.1,6 C9,6.2,8.9,6.3,8.8,6.5c0,0.1-0.1,0.1-0.1,0.2C8.7,6.9,8.6,7.2,8.5,7.4h-1c-0.3,0-0.5,0-0.7,0.1c-0.1,0-0.1,0-0.1,0 C6.4,7.6,6.2,7.7,6,7.8c0,0-0.1,0-0.1,0.1C5.7,7.9,5.5,8.1,5.3,8.2c0,0-0.1,0-0.1,0.1C5.1,8.4,4.9,8.6,4.8,8.8c0,0,0,0-0.1,0.1 C4.3,8.7,4,8.2,4,7.7V7.5z M20,11.3c0,0.9-0.7,1.7-1.6,1.7H7.6C6.7,13,6,12.2,6,11.3v-0.2c0-0.2,0-0.5,0.1-0.7c0.3-0.6,0.8-1,1.4-1 h1.9c0.6,0,1-0.4,1-1c0-1.5,1.1-2.7,2.6-2.7c0.4,0,0.9,0.1,1.3,0.4c0.8,0.5,1.3,1.4,1.3,2.4c0,0.6,0.4,1,1,1h1.9 c0.9,0,1.6,0.8,1.6,1.7V11.3z'
    ),
  ],
});

export enum WeatherStatus {
  Sunny = 1,
  Cloudy = 2,
  Rainy = 4,
  Stormy = 8,
  Snowy = 16,
  Foggy = 32,
}

const getWeatherIcon = (status: string | number) => {
  switch (status) {
    case WeatherStatus.Sunny:
      return sunnyWeatherIconDetail();
    case WeatherStatus.Cloudy:
      return cloudyWeatherIconDetail();
    case WeatherStatus.Rainy:
      return rainyWeatherIconDetail();
    case WeatherStatus.Stormy:
      return stormyWeatherIconDetail();
    case WeatherStatus.Snowy:
      return snowyWeatherIconDetail();
    case WeatherStatus.Foggy:
      return foggyWeatherIconDetail();
  }

  return notFoundSVGIcon();
};

export const getWeatherIconSet = (): SVGIconDetail[] =>
  getNumericObjectValues(WeatherStatus).map((value) => ({
    value,
    ...getWeatherIcon(value),
  }));
